import {
  CREATE_BROKER_FIRM_FAILURE,
  CREATE_BROKER_FIRM_REQUEST,
  CREATE_BROKER_FIRM_RESETSTATE,
  CREATE_BROKER_FIRM_SUCCESS,
  DELETE_BROKER_FIRM_FAILURE,
  DELETE_BROKER_FIRM_REQUEST,
  DELETE_BROKER_FIRM_SUCCESS,
  FETCH_BROKER_FIRMS_FAILURE,
  FETCH_BROKER_FIRMS_REQUEST,
  FETCH_BROKER_FIRMS_SUCCESS,
  UPDATE_BROKER_FIRM_FAILURE,
  UPDATE_BROKER_FIRM_REQUEST,
  UPDATE_BROKER_FIRM_SUCCESS
} from '../../actions/broker/types';

/**
 *
 * @type BrokerFirmState
 */
const initialState = {
  createFirm: { loading: false, data: null, error: null },
  deleteFirm: { loading: false, data: null, error: null },
  updateFirm: { loading: false, data: null, error: null },
  firmList: { loading: false, data: null, error: null },
};

/**
 *
 *
 *
 * @typedef {Object} ACTION
 * @property {string} type
 * @property {Array<*>} [payload]
 * @property {string} [error]
 *
 *
 *
 * @param { BrokerFirmState} state
 * @param {ACTION} action
 * @param {*} type
 *
 * @return {BrokerFirmState}
 */
const BrokerFirm = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_BROKER_FIRM_REQUEST:
      return {
        ...state,
        createFirm: { ...initialState.createFirm, loading: true },
      };
    case UPDATE_BROKER_FIRM_REQUEST:
      return {
        ...state,
        updateFirm: { ...initialState.createFirm, loading: true },
      };
    case DELETE_BROKER_FIRM_REQUEST:
      return {
        ...state,
        deleteFirm: { ...initialState.createFirm, loading: true },
      };
    case FETCH_BROKER_FIRMS_REQUEST: {
      return {
        ...state,
        firmList: { ...initialState.firmList, loading: true },
      };
    }
    case CREATE_BROKER_FIRM_SUCCESS: {
      return {
        ...state,
        createFirm: {
          ...state.createFirm,
          data: action.payload,
          loading: false,
          error: null,
        },
        firmList: addNewBrokerUserData(action.payload, {
          ...state.firmList,
        }),
      };
    }

    case FETCH_BROKER_FIRMS_SUCCESS:
      return {
        ...state,
        firmList: {
          ...state.firmList,
          loading: false,
          error: null,
          data: action.payload,
        },
      };

    case UPDATE_BROKER_FIRM_SUCCESS: {
      return {
        ...state,
        updateFirm: {
          ...state.updateFirm,
          loading: false,
          error: null,
          payload: action.payload,
        },
        firmList: updateBrokerFirmData(action.payload, {
          ...state.firmList,
        }),
      };
    }

    case DELETE_BROKER_FIRM_SUCCESS: {
      return {
        ...state,
        deleteFirm: {
          ...state.deleteFirm,
          loading: false,
          error: null,
          payload: action.payload,
        },
      };
    }
    case FETCH_BROKER_FIRMS_FAILURE:
      return {
        ...state,
        firmList: { data: null, loading: false, error: action.error ||"Error" },
      };
    case CREATE_BROKER_FIRM_FAILURE:
      return {
        ...state,
        createFirm: { data: null, loading: false, error: action.error||'Error' },
      };
    case UPDATE_BROKER_FIRM_FAILURE:
      return {
        ...state,
        updateFirm: { data: null, loading: false, error: action.error||'Error' },
      };
    case DELETE_BROKER_FIRM_FAILURE: {
      return {
        ...state,
        deleteFirm: { data: null, loading: false, error: action.error },
      };
    }
    case CREATE_BROKER_FIRM_RESETSTATE: {
      return {
        ...state,
        createFirm: { data: null, loading: false, error: null },
      };
    }
    default:
      return state;
  }
};

/**
 *
 * @param {BrokerFirm} dataToUpdate
 * @param {BrokerFirmListState} state
 * @returns {BrokerFirmListState}
 */
function updateBrokerFirmData(dataToUpdate, state) {
  state.data.data = state.data.data.map((obj) => {
    if (obj._id !== dataToUpdate._id) return obj;
    return { ...dataToUpdate };
  });

  return state;
}

/**
 *
 * @param {BrokerFirm} dataToUpdate
 * @param {BrokerFirmListState} state
 * @returns {BrokerFirmListState}
 */
function addNewBrokerUserData(dataToUpdate, state) {
  state.data.data = [ dataToUpdate,...state.data.data];
  state.data.total++;
  return state;
}

/**
 *
 * @param {*} state
 * @returns {BrokerFirmState['createFirm']}
 */
export const getCreateBrokerFirmState = (state) => state.brokerFirm.createFirm;
export const getUpdateBrokerFirmState = (state) => state.brokerFirm.updateFirm;


export default BrokerFirm;
